import { render, staticRenderFns } from "./achatEquipe.vue?vue&type=template&id=0980bec4&scoped=true&"
import script from "./achatEquipe.vue?vue&type=script&lang=js&"
export * from "./achatEquipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980bec4",
  null
  
)

export default component.exports